import React, { useEffect } from "react";
export default function GameImage({ game, isDesktop, startGame, goLazyImage, brands, icon, loggedIn }) {
    const isIcon = icon ? "-xicon" : ""
    const imageSrc = casinoModule.config.gameImagesUrl + brands[game.bID].nameNormalizirano + "/" + casinoModule.utils.normalizeString(game.n, isDesktop) + isIcon;
    const webP = casinoModule.config.canIUseWebP ? '.webp' : '.jpeg';
    const imgUrl = imageSrc + webP + "?c=" + casinoModule.constants.cache;

    useEffect(() => {
/*        casinoModule.utils.lazyImages.mountEventLazyLoadImages();*/
    }, [])

    return (
        <>
            <div className="game-overlay">
                {game?.jp > 0 &&
                    <div className="game-jackpot">
                        <div className="jackpot-image" />
                        <p className="jackpot-value">
                            <span className="line" />
                            {casinoModule.utils.toMoneySeparatedWithDecimals(game.jp)}
                            <span className="line" />
                        </p>
                    </div>
                }
                <div className="game-controls">
                    <button className="game-btn standard"
                        onClick={() => startGame(game.s, icon ? !loggedIn : false)}>
                        <div className="play-icon" />{!icon && "ZAIGRAJ"}
                    </button>
                    {!icon &&
                        <button className="game-btn demo"
                            onClick={() => startGame(game.s, true)}>
                            <div className="play-demo-icon" />ISPROBAJ
                        </button>
                    }
                </div>
            </div>

            {game &&
                <div
                    //data-lazyid={game.s}
                    className={"game-img"}
                    style={{ 'backgroundImage': 'url("' + imgUrl + '")' }}
                />
            }
        </>
    );
};

